import React from 'react';
import './index.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';

const PharmaciesBanner = () => {
  const { t } = useTranslation();
  return (
    <div className="pharmaciesNationwideContainer">
      <div className="pharmaciesWrapper">
        <h2 className="nationwiseTitle textCenter">
          {t('Available at more than')}&nbsp;
          <span>35,000+{t(' pharmacies')}</span>
        </h2>
        <div className="imageWrapper">
          <ul>
            <li>
              <LazyLoadImage
                src="/content/images/pharmacy/logos-walgreens.svg"
                alt={t('Walgreens logo')}
                height="27px"
                width="129px"
              />
            </li>
            <li>
              <LazyLoadImage
                src="/content/images/pharmacy/logos-kroger.svg"
                alt={t('Kroger logo')}
                height="47px"
                width="84px"
              />
            </li>
            <li>
              <LazyLoadImage
                src="/content/images/pharmacy/logos-walmart.svg"
                alt={t('Walmart logo')}
                height="32px"
                width="127px"
              />
            </li>
            <li>
              <LazyLoadImage
                src="/content/images/pharmacy/logos-cvs.svg"
                alt={t('CVS Pharmacy logo')}
                height="24px"
                width="185px"
              />
            </li>
          </ul>

          <ul>
            <li>
              <LazyLoadImage
                src="/content/images/pharmacy/logos-safeway.svg"
                alt={t('frys logo')}
                height="36px"
                width="129px"
              />
            </li>
            <li>
              <LazyLoadImage
                src="/content/images/pharmacy/logos-king.svg"
                alt={t('King Soopers logo')}
                height="38px"
                width="66px"
              />
            </li>
            <li>
              <LazyLoadImage
                src="/content/images/pharmacy/logos-smiths.svg"
                alt={t('Smiths logo')}
                height="23px"
                width="75px"
              />
            </li>
            <li>
              <LazyLoadImage
                src="/content/images/pharmacy/logos-fredmeyer.svg"
                alt={t('Fredmeyer logo')}
                height="33px"
                width="116px"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PharmaciesBanner;
